import React from 'react'
import Header from '../components/layout/Header'
import HeroSection from '../components/layout/HeroSection'
import Footer from '../components/layout/Footer'

const Homepage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <HeroSection />
      </main>
      <Footer />
    </div>
  )
}

export default Homepage